import { useState, useEffect } from "react"
import { db } from "../../firebase"

/**
 * Returns the entire set of a collection
 */

function useCollection (
  path: string,  // path to the collection (from root reference)
  options?: { limit?: number },
): [
  Record<string, any>[] | null,
  Record<string, any> | null,
  boolean,
  Record<string, any> | null,
  Record<string, any> | null,
] {
  const [loading, setLoading] = useState(true)
  const [ref, setRef] = useState<Record<string, any> | null>(null)
  const [querySnapshot, setQuerySnapshot] =
    useState<Record<string, any> | null>(null)
  const [collectionDocuments, setCollectionDocuments] =
    useState<Record<string, any>[] | null>([])
  const [error, setError] = useState<Record<string, any> | null>(null)

  const maxDocs = options?.limit
  let query: any = db.collection(path)
  if (maxDocs) {
    query = query.limit(maxDocs)
  }

  useEffect(() => {
    if (!path) {
      return
    }
    setRef(db.collection(path))
    const unlisten = query.onSnapshot((querySnapshot: any) => {
      const docs: Record<string, any>[] = []
      querySnapshot.forEach((value: any) => {
        if (value.exists) {
          docs.push(value.data())
        }
      })
      setCollectionDocuments(docs)
      setQuerySnapshot(querySnapshot)
      setLoading(false)
    }, (error: any) => {
      setLoading(false)
      setError(error)
    })
    return unlisten
  }, [path])

  return [collectionDocuments, querySnapshot, loading, error, ref]
}

export default useCollection
